export default [
  {
    key: 'id',
    type: 'id',
  },
  {
    key: 'image_url',
    type: 'image',
    label: 'Gambar',
  },
  {
    key: 'name',
    label: 'Nama',
  },
  {
    key: 'parent',
    label: 'Parent',
  },
  {
    key: 'order',
    label: 'Urutan',
    type: 'number',
  },
  {
    key: 'is_essential',
    label: 'Esensial',
    type: 'badge',
    translationPrefix: 'category.',
    map: {
      true: 'success',
      false: 'secondary',
    },
    filter: {
      key: 'is_essential',
      type: 'select',
      label: 'Esensial',
      options: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
    },
  },
]
